/*eslint-disable no-undef*/
import React from 'react';
import http from './http';
import { getOptions } from './options';
import noimage from '../images/nobook.png';

const APIurl = 'https://www.googleapis.com/books/v1/';

/**
 * Query Google Books API
 *
 * @param {string} query - Keyword to run search
 * @param {int} perPage - Results per page
 * @param {int} startIndex - Offset
 *
 * @returns {Promise} - Response from API
 */
async function search(query, perPage, startIndex) {
  const {
    data: { gbi_apikey }
  } = await getOptions();

  let request =
    APIurl +
    'volumes?q=' +
    query +
    '&maxResults=' +
    perPage +
    '&startIndex=' +
    startIndex;

  if (gbi_apikey) {
    request += '&key=' + gbi_apikey;
  }

  return http.get(request);
}

/**
 * Insert
 */
function insert(id) {
  const restAPIURL = restURL + 'google-books-importer/v1/addbook';
  return http.post(
    restAPIURL,
    { id },
    { headers: { 'X-WP-Nonce': restNonce } }
  );
}

/**
 * This method maps all of the info from Google books API into proper values. What we need:
 * - id
 * - title
 * - image URL
 * - subtitle
 * - description
 * - authors
 * - canonical volume link
 * - preview link
 * - publisher
 *
 * @param {Object} booksRaw - data from Google books API
 *
 * @returns {Object} books - Needed pieces for each book
 */
function mapSearchResults(booksRaw) {
  const books = booksRaw.map(book => {
    const newBook = {};
    newBook.id = book.id;
    newBook.title = book.volumeInfo.title ? (
      book.volumeInfo.title.substr(0, 88)
    ) : (
      <i>No Title.</i>
    );
    newBook.image = book.volumeInfo.imageLinks
      ? book.volumeInfo.imageLinks.smallThumbnail
      : noimage;
    newBook.subtitle = book.volumeInfo.subtitle
      ? book.volumeInfo.subtitle.substr(0, 44)
      : '';
    newBook.description = book.volumeInfo.description ? (
      book.volumeInfo.description.substr(0, 290)
    ) : (
      <i>No Description.</i>
    );
    newBook.authors = book.volumeInfo.authors
      ? book.volumeInfo.authors.slice(0, 4)
      : [];
    newBook.link = book.volumeInfo.canonicalVolumeLink
      ? book.volumeInfo.canonicalVolumeLink
      : '';
    newBook.previewLink = book.volumeInfo.previewLink
      ? book.volumeInfo.previewLink
      : '';
    newBook.publisher = book.volumeInfo.publisher
      ? book.volumeInfo.publisher
      : '';
    return newBook;
  });
  return books;
}

export default {
  search,
  insert,
  mapSearchResults
};



// WEBPACK FOOTER //
// ./src/services/books.js